// src/hooks/useThemeContext.js
import { useContext } from "react";
import { ThemeContext } from "../App"; // Import from App.js in src folder

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useThemeContext must be used within ThemeProvider");
  }
  return context;
};